import React, { useState } from "react";
import { X, Rocket } from "lucide-react";

const AnnouncementBanner = () => {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  return (
    <div
      data-testid="announcement-banner"
      className="relative z-[60] bg-[#FF2A2A] text-white border-b-2 border-black"
      style={{ boxShadow: "0 2px 10px rgba(255, 42, 42, 0.4)" }}
    >
      <div className="px-4 md:px-12 lg:px-24 py-2.5 flex items-center justify-center gap-3 text-center">
        <Rocket size={14} strokeWidth={2.5} className="shrink-0 hidden sm:block" />
        <p className="font-mono-plex text-[11px] md:text-xs tracking-[0.15em] uppercase font-bold leading-snug">
          Pre-Concert Stop for Toyota Center, Minute Maid Park &amp; Theater
          District Events!
        </p>
        <button
          onClick={() => setOpen(false)}
          data-testid="announcement-close"
          aria-label="Dismiss announcement"
          className="ml-2 hover:bg-black hover:text-[#FF2A2A] transition-colors p-1 rounded-sm shrink-0"
        >
          <X size={14} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
